var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _circle2, _rect, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefRobotLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 311,
    height: 307,
    viewBox: "0 0 311 307",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M301.744 82.2843C296.496 57.5383 277.713 38.0807 268.092 29.2532C239.887 9.25228 224.913 7.09992 206.026 4.38506L205.654 4.33167C176.241 0.102627 111.336 0.492238 84.3969 8.48042C50.7234 18.4656 31.4814 38.4361 20.1111 59.2748C8.74091 80.1136 -2.57205 114.851 3.88608 181.047C9.44031 237.978 38.479 251.165 62.0937 264.189L101.015 284.16L147.808 304.998C181.621 292.131 221.715 273.827 254.951 255.072C296.496 231.629 304.368 189.517 306.554 179.098C311.2 156.956 307.401 108.964 301.744 82.2843Z",
    stroke: "white",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M248.866 178.609H304.645L303.337 185.237L301.594 192.749L298.98 200.702L295.493 209.098C272.136 209.451 253.95 208.95 251.481 207.772C246.949 201.763 247.995 184.648 248.866 178.609Z",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M232.635 75.1923C237.179 54.2439 264.228 40.377 274.715 37.0311C246.325 4.94657 210.862 3.17736 176.145 1.44533L175.392 1.40774C146.994 -0.0103056 94.3588 1.79417 67.4601 14.5007C35.1244 29.7756 19.1349 54.8612 10.8325 80.6102C2.53003 106.359 0.64975 147.723 3.42685 174.106C6.21982 200.639 14.1302 243.911 50.8553 254.533C91.4934 266.288 143.056 262.36 186.316 252.351C224.582 243.498 228.701 201.328 230.449 183.431L230.45 183.425C232.198 165.532 226.954 101.378 232.635 75.1923Z",
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M144.773 150.704V150.76L144.766 150.815C144.148 156.338 146.454 162.041 150.432 166.389C154.408 170.736 159.958 173.619 165.671 173.619C171.315 173.619 176.534 170.271 180.387 165.625C184.243 160.976 186.57 155.215 186.57 150.704C186.57 146.148 184.69 140.72 181.109 136.438C177.547 132.178 172.339 129.094 165.671 129.094H165.643L165.615 129.092C158.309 128.678 153.139 131.758 149.762 136.086C146.355 140.452 144.773 146.099 144.773 150.704Z",
    stroke: "white",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6944 150.704V150.76L29.6882 150.815C29.0701 156.338 31.3757 162.041 35.3536 166.389C39.3302 170.736 44.8797 173.619 50.5933 173.619C56.2372 173.619 61.4557 170.271 65.3084 165.625C69.165 160.976 71.4922 155.215 71.4922 150.704C71.4922 146.148 69.6116 140.72 66.0314 136.438C62.4686 132.178 57.2611 129.094 50.5933 129.094H50.565L50.5367 129.092C43.2308 128.678 38.0606 131.758 34.6838 136.086C31.2773 140.452 29.6944 146.099 29.6944 150.704Z",
    stroke: "white",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M157.307 144.02C157.307 147.393 160.458 150.338 164.622 150.338C168.786 150.338 171.938 147.393 171.938 144.02C171.938 140.648 168.786 137.703 164.622 137.703C160.458 137.703 157.307 140.648 157.307 144.02Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8933 144.02C42.8933 147.393 46.0444 150.338 50.2084 150.338C54.3723 150.338 57.5234 147.393 57.5234 144.02C57.5234 140.648 54.3723 137.703 50.2084 137.703C46.0444 137.703 42.8933 140.648 42.8933 144.02Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.66302,
    cy: 1.66302,
    r: 1.16302,
    transform: "matrix(-1 0 0 1 62.5117 149.34)",
    fill: "white",
    stroke: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.66302,
    cy: 1.66302,
    r: 1.16302,
    transform: "matrix(-1 0 0 1 176.926 149.34)",
    fill: "white",
    stroke: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 1,
    width: 39.2428,
    height: 8.64331,
    rx: 4.32166,
    transform: "matrix(-1 0 0 1 123.707 205.219)",
    stroke: "white",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M183.51 193.143C193.63 178.361 219.342 177.412 230.684 178.732C228.843 204.274 226.055 214.835 216.335 231.497C207.923 245.918 191.798 252.417 176.531 254.177V216.9C176.531 202.382 181.329 196.809 183.51 193.143Z",
    stroke: "white",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M246.951 79.3485C251.717 72.3014 268.828 62.7815 278.116 58.207L288.016 84.9121C281.269 85.8022 257.584 98.6355 246.218 119.406L241.451 94.5555C241.696 92.9483 242.578 85.8137 246.951 79.3485Z",
    stroke: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M237.69 247.235L295.484 210.207L293.17 216.687L289.004 223.167C285.287 228.698 280.245 235.698 270.953 243.532C263.518 249.801 256.605 254.178 241.331 262.509L226.983 270.097H178.211L127.071 271.678L82.0104 273.068L51.9736 257.848L46.4711 254.178C80.6597 263.458 150.702 262.353 186.761 255.716L237.69 247.235Z",
    stroke: "white",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M254.536 185.262H296.668L293.342 195.55L255.645 195.905C253.871 193.634 253.797 187.863 254.536 185.262Z",
    stroke: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M200.127 275.008H166.999L146.91 297.625L200.127 275.008Z",
    stroke: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefRobotLine);
export default __webpack_public_path__ + "static/media/RefRobotLine.6ec077c7725e70c1268c4ea727fab51d.svg";
export { ForwardRef as ReactComponent };